import { Pipe, PipeTransform } from '@angular/core';
import { LatLngLike } from '@features/map/map.models';
import { Feature, FeatureCollection, GeoJsonProperties, Point } from 'geojson';

@Pipe({
    name: 'toGeoJson',
    standalone: true
})
export class ToGeoJsonPipe implements PipeTransform {
    transform<T>(data?: LatLngLike<T>[]): FeatureCollection<Point, GeoJsonProperties> {
        if (!data?.length) {
            return { type: 'FeatureCollection', features: [] };
        }

        const features: Feature<Point, GeoJsonProperties>[] = data
            .filter(({ latitude, longitude }) => Boolean(latitude && longitude))
            .map(feature => ({
                type: 'Feature',
                properties: feature as GeoJsonProperties,
                geometry: {
                    type: 'Point',
                    coordinates: [Number(feature.longitude), Number(feature.latitude)]
                }
            }));

        return { type: 'FeatureCollection', features };
    }
}
